import { daysOfWeek } from './days';

export const weekdays = daysOfWeek;

export const periodTime = [
  { value: 'morning', label: 'Morning', order: 0 },
  { value: 'afternoon', label: 'Afternoon', order: 1 },
  { value: 'evening', label: 'Evening', order: 2 },
];

export const weeks = [
  { value: 'first', label: 'First', order: 0 },
  { value: 'second', label: 'Second', order: 1 },
  { value: 'third', label: 'Third', order: 2 },
  { value: 'fourth', label: 'Fourth', order: 3 },
];

export const shiftTypes = [
  { value: 'vaccination', label: 'Limited-Service Clinic', order: 0 },
  { value: 'wellness', label: 'Limited-Service Hospital', order: 1 },
  { value: 'hospital', label: 'Full-Service Hospital', order: 2 },
];

export const areas = [
  { value: 'wellness', label: 'Wellness', order: 0 },
  { value: 'nonWellness', label: 'Non-Wellness', order: 1 },
  { value: 'dental', label: 'Dental', order: 2 },
  { value: 'electiveSurgery', label: 'Routine Elective Surgery', order: 3 },
  { value: 'nonElectiveSurgery', label: 'Non-Elective Soft Tissue Surgery', order: 4 },
  { value: 'euthanasia', label: 'Euthanasia', order: 5 },
];
